module.exports = __webpack_public_path__ + "static/img-5-e3a331e70bc05b6820911733ed170972.jpg";